import { FC, useEffect, useState } from "react";
import { Button, ButtonProps } from "@smile2impress/components";
import { useTranslation } from "next-i18next";
import { useGoToBooking } from "hooks/useGoToBooking";

import { BOOKING_FORM_ID } from "components/BookingForm";
import Link from "components/Link";

export const StickyBookButton: FC<ButtonProps> = (props) => {
    const { goToBooking } = useGoToBooking();
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const bookingFormElement = document.getElementById(BOOKING_FORM_ID);

        if (!bookingFormElement) {
            return;
        }

        const intersectionObserver = new IntersectionObserver(
            (entries) => {
                const isIntersecting =
                    entries[entries.length - 1]?.isIntersecting;

                setIsVisible(!isIntersecting);
            },
            { threshold: 0.1 }
        );
        intersectionObserver.observe(bookingFormElement);

        return () => {
            intersectionObserver.disconnect();
        };
    }, []);

    return (
        <Button
            width="100%"
            {...(props.href ? { as: Link } : { onClick: goToBooking })}
            transition={"transform .5s"}
            translateY={isVisible ? 0 : "150%"}
            transform={"auto"}
            display={["block", "block", "none"]}
            textAlign="center"
            {...props}
        >
            {props.children || t("global:cta")}
        </Button>
    );
};
